import { Component, Inject, ViewChild, ElementRef } from '@angular/core';
import {
  MatLegacyDialogRef as MatDialogRef,
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
} from '@angular/material/legacy-dialog';
import { AuthService, LoginRequest, UserData } from '../../../../services/auth/auth.service';
import { StorageService } from '../../../../services/storage/storage.service';
import { SharedService } from './../../../../services/shared/shared.service';
import { Library } from '../../../../core/interfaces/library.interface';
import { LoginConfig } from '../../../../services/opac-settings/opac-settings.service';

@Component({
  selector: 'ag-nopassword-dialog',
  templateUrl: './no-pwdialog.component.html',
  styleUrls: ['./no-pwdialog.component.scss'],
})
export class NoPasswordDialog {
  @ViewChild('userInput') userInput: ElementRef;
  userName = '';
  showSelection: boolean;
  showInputBox: boolean;
  submitting = false;

  constructor(
    private _authService: AuthService,
    private _dialogRef: MatDialogRef<NoPasswordDialog>,
    private _sharedService: SharedService,
    private _storageService: StorageService,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      loginConfig: LoginConfig;
      userData: UserData;
      library: Library;
    },
  ) {
    this.submitting = false;
    this.showSelection = true;
    this.showInputBox = false;
  }

  submit(val) {
    if (val === 'patron' && !this.data.library.hasEzproxy && !this.data.library.hasSaml) {
      // show an input box with a field to enter username
      this.showSelection = false;
      this.showInputBox = true;
      setTimeout(() => {
        this.userInput.nativeElement.focus();
      }, 200);
    } else {
      this._dialogRef.close({ userType: val });
    }
  }

  submitUserName() {
    this.submitting = true;
    const body: LoginRequest = {
      grant_Type: 'password',
      cid: this.data.userData.customerId,
      lid: this.data.userData.libraryId,
      password: '',
      rememberMe: true,
      userName: this.userName,
      guestToken: this._storageService.getItem('access_Token'),
    };

    this._authService.login(body).subscribe(
      (userData) => {
        this._dialogRef.close({
          userType: 'patron',
          userData: userData,
        });
      },
      (error: unknown) => {
        if (error instanceof Error) {
          this._sharedService.openSnackBar(error.message);
        }
        this.submitting = false;
      },
    );
  }

  goBack() {
    this.showSelection = true;
    this.showInputBox = false;
    this.userName = '';
  }
}
